var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(-1187 -371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(1187 371)",
    fill: "#fff",
    stroke: "#e4e7eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M8.729,10.211H14.8a.8.8,0,0,1,0,1.6H8.729l1.84,1.84a.8.8,0,1,1-1.05,1.207.741.741,0,0,1-.086-.087l-3.2-3.2a.8.8,0,0,1,0-1.12l3.2-3.2a.8.8,0,0,1,1.136,1.12l-1.848,1.84Z",
    transform: "translate(1184.945 390.601) rotate(-90)",
    fill: "#ef4e4e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownStock);
export default __webpack_public_path__ + "static/media/arrow-down-stock.805c117089ef6268322c68e4c177fa5c.svg";
export { ForwardRef as ReactComponent };